<div class="rd-widget widget-2xCol leaseCompsMapWidget rd-widget-no-height-restriction" [style.height.px]="widgetHeight" *ngIf="widgetData">
  <table aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="widgetImagePlaceholder"
            colspan="16"
            [ngStyle]="{ 'background': 'url(' + widgetData.pictureDataUrl + ')'}">
        </td>
      </tr>
    </tbody>

  </table>
</div>
